import { useNavigate, useLocation } from 'react-router-dom';

const navItems = [
  { path: '/customer-insight', icon: 'ri-team', label: '客户' },
  { path: '/market-insight', icon: 'ri-bar-chart', label: '市场' },
  { path: '/script-assistant', icon: 'ri-chat-quote', label: '话术' },
  { path: '/product-search', icon: 'ri-briefcase', label: '产品' },
  { path: '/profile', icon: 'ri-user', label: '我的' },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-gray-100 px-0 py-2 grid grid-cols-5 z-50">
      {navItems.map((item) => {
        const isActive = location.pathname === item.path;
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className="flex flex-col items-center justify-center gap-0.5"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`${item.icon}-${isActive ? 'fill' : 'line'} text-xl ${isActive ? 'text-blue-600' : 'text-gray-400'}`}></i>
            </div>
            <span className={`text-[0.625rem] ${isActive ? 'text-blue-600 font-medium' : 'text-gray-400'}`}>
              {item.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
